import { MonetizationType } from '@/@types/graphql-types';

export const ProviderTypes = ['all', 'my_services', 'free', 'buy_rent', 'subscription', 'cinema'] as const;
export type ProviderType = (typeof ProviderTypes)[number];

export type ProviderTypeWithMonetizationTypes = Exclude<ProviderType, 'all' | 'my_services'>;

export const ProviderTypeToMonetizationTypes: Record<ProviderTypeWithMonetizationTypes, MonetizationType[]> = {
	buy_rent: [MonetizationType.Buy, MonetizationType.Rent],
	free: [MonetizationType.Free, MonetizationType.Ads],
	subscription: [MonetizationType.Flatrate, MonetizationType.FlatrateAndBuy],
	cinema: [MonetizationType.Cinema],
};

// The reverse of ProviderTypeWithMonetizationTypes for creating `providersByType` in `useConstantStore`
export const MonetizationTypeToProviderType: Record<MonetizationType, ProviderTypeWithMonetizationTypes | null> = {
	[MonetizationType.Buy]: 'buy_rent',
	[MonetizationType.Rent]: 'buy_rent',
	[MonetizationType.Free]: 'free',
	[MonetizationType.Ads]: 'free',
	[MonetizationType.Flatrate]: 'subscription',
	[MonetizationType.FlatrateAndBuy]: 'subscription',
	[MonetizationType.Cinema]: 'cinema',

	[MonetizationType.Fast]: null,
	[MonetizationType.LinearFree]: null,
	[MonetizationType.LinearFlatrate]: null,
};
